import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["baseLimit", "previousBaseLimit", "baseMin", "row", "pastRow"]

  connect() {
    this.update = this.update.bind(this)
  }

  update() {
    const limit = parseFloat(this.baseLimitTarget.value) || 0
    const min = parseFloat(this.baseMinTarget.value) || 0

    this.rowTargets.forEach(row => {
      const conversionRateField = row.querySelector('input[name*="[conversion_rate]"]')
      if (!conversionRateField) return

      const rate = parseFloat(conversionRateField.value) || 1
      const localLimitField = row.querySelector('input[name*="[matching_limit]"]')
      const localMinField = row.querySelector('input[name*="[minimum_donation_amount]"]')

      if (localLimitField) localLimitField.value = (limit * rate).toFixed(2)
      if (localMinField) localMinField.value = (min * rate).toFixed(2)
    })
  }

  updatePrevious() {
    const limit = parseFloat(this.previousBaseLimitTarget.value) || 0

    this.pastRowTargets.forEach(row => {
      const conversionRateField = row.querySelector('input[name*="[conversion_rate]"]')
      if (!conversionRateField) return

      const rate = parseFloat(conversionRateField.value) || 1
      const localLimitField = row.querySelector('input[name*="[matching_limit]"]')

      if (localLimitField) localLimitField.value = (limit * rate).toFixed(2)
    })
  }

  confirmUncheck(event) {
    if (!event.target.checked) {
      alert("On submitting the form, your Local Match Settings will be disabled.\n\n" +
        "This will delete all stored local allowance settings for your company.\n" +
        "Once deleted, these settings cannot be restored automatically.")
    }
  }

  enableCheckbox(event) {
    const row = event.target.closest('[data-local-match-settings-target]')
    if (!row) return

    const checkbox = row.querySelector('input[type="checkbox"][name*="[active]"]')
    if (checkbox) checkbox.checked = true
  }
}
